import React from 'react';
const NumberConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/number',
			component: React.lazy(() => import('./NumberManagement.js'))
		}
	]
};

export default NumberConfig;
